import { createListFilters } from '../../../../../components'

export type NotaAtendimentosFilters = {
  /** Busca local por protocolo (a nota vem inteira, sem paginação). */
  protocolo: string
}

export const { ListFiltersProvider, useListFilters } = createListFilters<NotaAtendimentosFilters>({
  protocolo: '',
})
